// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_extract-text-webpack-plugin@0.8.2@extract-text-webpack-plugin/loader.js?{"remove":true}!./~/_css-loader@0.21.0@css-loader!./~/_vue-loader@9.9.5@vue-loader/lib/style-rewriter.js?id=data-v-c0ff4e7e!./~/_stylus-loader@2.5.1@stylus-loader!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=styles&index=0!./src/nav/nav-image.vue
// module id = 20
// module chunks = 0